import React, { Component } from "react";

import { Button } from "reactstrap";
import { goToTop } from "react-scrollable-anchor";
import jobs from "../../data/jobs.json";

import "./career.scss";
import arrowHeader from "../../assets/images/arrowHeader.svg";
import group from "../../assets/images/group.png";
import F from "../../assets/images/F.svg";
import C from "../../assets/images/C.svg";
import H from "../../assets/images/H.svg";
import W from "../../assets/images/W.svg";
import L from "../../assets/images/L.svg";

export default class Career extends Component {
  constructor(props) {
    super(props);
    goToTop();
    this.state = {
      jobs: jobs
    };
  }
  render() {
    return (
      <div className="container-career">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <h1 className="career-title text-center">Jobs at Wizy</h1>
            </div>
            <div className="offset-md-2 col-md-8">
              <p className="career-description text-center">
                We are always seeking the new talents who can bring new
                perspectives and experiences to our team
              </p>
            </div>
            <div className="offset-md-3 col-md-6">
              {/* <Button className="btn-job" outline color="primary" onClick={() => { this.props.history.push('#open-roles') }}>
                See Open Roles<img src={arrowHeader} alt="" />
              </Button> */}

              <Button className="btn-job" outline color="primary">
                <a href="#open-roles">
                  See Open Roles
                  <img src={arrowHeader} alt="" />
                </a>
              </Button>
            </div>
            <div className="col-md-12">
              <img src={group} alt="" />
              <h4 className="benefit-title text-center">
                The Benefits of Wizy Team Members
              </h4>
            </div>
            <div className="offset-md-2 col-md-4 benefit-block">
              <h6 className="benefit-block-title">
                <img src={F} alt="" />
                Flexible work hours
              </h6>
              <p className="benefit-description">
                Flexible working time. Trust-based Time Off (take the days you
                need).
              </p>
            </div>
            <div className="col-md-4 benefit-block">
              <h6 className="benefit-block-title">
                <img src={C} alt="" />
                Competitive salary
              </h6>
              <p className="benefit-description">
                Competitive salary & attractive compensation package and
                benefits.
              </p>
            </div>
            <div className="offset-md-2 col-md-4 benefit-block">
              <h6 className="benefit-block-title">
                <img src={W} alt="" />
                Well equipment
              </h6>
              <p className="benefit-description">
                We equip you with a powerful computer and a big external screen.
              </p>
            </div>
            <div className="col-md-4 benefit-block">
              <h6 className="benefit-block-title">
                <img src={H} alt="" />
                Health benefits{" "}
              </h6>
              <p className="benefit-description">
                Gym, Yoga, Boxing, Swimming. We all get everyday workout to undo
                the damage caused by sitting.
              </p>
            </div>
            <div className="offset-md-2 col-md-4 benefit-block">
              <h6 className="benefit-block-title">
                <img src={L} alt="" />
                Incubator support
              </h6>
              <p className="benefit-description">
                We are motivated with innovative ideas and open to support for
                side projects.
              </p>
            </div>
          </div>
        </div>
        <div className="row ">
          <div className="seeking-human">
            <div className="col-md-6">
              <p className="seeking-human-title text-center">
                We are here to make ourselves better. We care to each others, we
                try to create useful things and we deliver good projects
                together.
              </p>
              <p className="seeking-human-description text-center">
                You're looking for new challenges. Joining the core team, you
                have the opportunities to develop yourself to another level in
                your career path.
              </p>
            </div>
          </div>
        </div>
        <div className="container">
          <div className="row">
            <div className="offset-md-3 col-md-6" id="open-roles">
              <h4 className="role-title text-center">Open Roles</h4>
              <p className="role-description text-center">
                Discover the right role for you and please feel free to contact
                us. We're looking forward to talking to you.
              </p>
            </div>

            {this.state.jobs.map(
              (job, index) =>
                !job.hide && (
                  <div
                    key={index}
                    className="offset-md-3 col-md-6 job-block"
                    onClick={() => {
                      this.props.history.push("/job-details/" + job.id);
                    }}
                  >
                    <div className="row">
                      <div className="col-md-12">
                        <div className="job-header">
                          <h6 className="job-title">
                            {job.title}
                            <span> ( {job.quantity} )</span>
                          </h6>
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-9">
                        <div className="job-content">
                          <p className="job-description">
                            Location: {job.location} | {job.jobType}
                          </p>
                        </div>
                      </div>

                      <div className="col-md-3 job-detail">
                        <button
                          type="button"
                          className="btn btn-link button-job"
                        >
                          <h6>
                            View Details
                            <img src={arrowHeader} alt="" />
                          </h6>
                        </button>
                      </div>
                    </div>
                  </div>
                )
            )}

            <div className="offset-md-4 col-md-4 see-more-block">
              <p className="text-looking text-center">
                Don't see the position you're looking for?
              </p>
              <p className="text-center">
                Please{" "}
                <a className="tell-us" href="mailto:hr@wizy.vn">
                  contact us for other positions
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/screens/Career/Career.js